import { CollectionEntity } from "@busy-human/gearbox";
export var Agency;
(function (Agency) {
    Agency.Relationships = {};
    function Default() {
        return {
            name: ""
        };
    }
    Agency.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = Agency.Relationships;
        defaults() {
            return Default();
        }
    }
    Agency.CollectionClass = CollectionClass;
})(Agency || (Agency = {}));
//# sourceMappingURL=index.js.map